function SSOService($q, halClient, LoginService) {
    'ngInject';

    return {
        memberLogin(options) {
            const deferred = $q.defer();
            if (!options.root) {
                options.root = '';
            }
            const url = options.root + '/api/v1/login/sso/' + options.company_id;
            const data = {token: options.member_sso};
            halClient.$post(url, {}, data).then((login) => {
                    return login.$get('member').then((member) => {
                            member = LoginService.setLogin(member);
                            return deferred.resolve(member);
                        }
                    );
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        adminLogin(options) {
            const deferred = $q.defer();
            if (!options.root) {
                options.root = '';
            }
            const url = options.root + '/api/v1/login/admin_sso/' + options.company_id;
            const data = {token: options.admin_sso};
            halClient.$post(url, {}, data).then((login) => {
                    return login.$get('administrator').then((admin) => {
                            return deferred.resolve(admin);
                        }
                    );
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        }
    };
}

angular
    .module('BB')
    .service('SSOService', SSOService);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/sso.service.js